import DisciplineInscriptionService from "@/services/DisciplineInscriptionService";

export default {
    state() {
        return {
            disciplineInscriptionsData: []
        }
    },

    getters: {
        getDisciplineInscriptionsData: (state) => state.disciplineInscriptionsData
    },

    mutations: {
        setDisciplineInscriptionsData(state, data) {
            state.disciplineInscriptionsData = Array.isArray(data) ? data : []
        },

        appendDisciplineInscriptionsData(state, data) {
            if (!Array.isArray(data) || data.length === 0) return

            const existingIds = new Set(state.disciplineInscriptionsData.map((item) => item.id))
            const fresh = data.filter((item) => !existingIds.has(item.id))

            state.disciplineInscriptionsData = [...state.disciplineInscriptionsData, ...fresh]
        },

        includeDisciplineInscriptions(state, data) {
            const items = Array.isArray(data) ? data : [data]
            state.disciplineInscriptionsData.push(...items)
        },

        updateDisciplineInscriptionData(state, data) {
            const index = state.disciplineInscriptionsData.findIndex((item) => item.id === data.id)
            if (index !== -1) state.disciplineInscriptionsData[index] = data
        },

        removeDisciplineInscription(state, id) {
            state.disciplineInscriptionsData = state.disciplineInscriptionsData.filter((item) => item.id !== id)
        },

        resetDisciplineInscriptions(state) {
            state.disciplineInscriptionsData = []
        }
    },

    actions: {
        async getDisciplineInscriptions({ commit, dispatch }, payload) {
            try {
                const response = await DisciplineInscriptionService.getDisciplineInscriptions(payload.data, payload.userToken);

                payload.append === true
                    ? commit('appendDisciplineInscriptionsData', response.data)
                    : commit('setDisciplineInscriptionsData', response.data)

                return response.data;
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', {
                    text: error?.response?.data?.message ?? 'Erro ao consultar inscrições, tente novamente!'
                })
                throw error;
            } finally {
                if (payload.skeletonKey) {
                    dispatch('skeleton/setLoadingState', { key: payload.skeletonKey, value: false })
                }
            }
        },

        async createDisciplineInscription({ commit, dispatch }, payload) {
            try {
                const response = await DisciplineInscriptionService.createDisciplineInscription(payload.data, payload.userToken);

                commit('includeDisciplineInscriptions', response.data)
                dispatch('toastfy/activeSuccesNotification', { text: 'Inscrição criada com sucesso!' })

                return response.data;
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', {
                    text: error?.response?.data?.message ?? 'Erro ao criar inscrição, tente novamente!'
                })
                throw error;
            }
        },

        async updateDisciplineInscription({ commit, dispatch }, payload) {
            try {
                const response = await DisciplineInscriptionService.updateDisciplineInscription(payload.data, payload.userToken);

                commit('updateDisciplineInscriptionData', response.data)
                dispatch('toastfy/activeSuccesNotification', { text: 'Inscrição atualizada com sucesso!' })

                return response.data;
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', {
                    text: error?.response?.data?.message ?? 'Erro ao atualizar inscrição, tente novamente!'
                })
                throw error;
            }
        },

        async deleteDisciplineInscription({ commit, dispatch }, payload) {
            try {
                dispatch('setLoadingState', { loadignState: true, loadingView: 'classDiscipline' })
                await DisciplineInscriptionService.deleteDisciplineInscription(payload, payload.userToken);

                commit('removeDisciplineInscription', payload.disciplineInscriptionId)
                dispatch('toastfy/activeSuccesNotification', { text: 'Inscrição removida com sucesso!' })
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', {
                    text: error?.response?.data?.message ?? 'Erro ao remover inscrição, tente novamente!'
                })
            } finally {
                dispatch('setLoadingState', { loadignState: false })
            }
        }
    }
}
